// Protege o React contra nós injetados por tradutores (Google Translate) — evita "removeChild"/"insertBefore" crash
if (typeof Node === "function" && Node.prototype) {
  const origRemove = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) return child;
    return origRemove.call(this, child);
  };
  const origInsert = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, ref) {
    if (ref && ref.parentNode !== this) return origInsert.call(this, newNode, null);
    return origInsert.call(this, newNode, ref);
  };
}
document.documentElement.setAttribute("translate", "no");
document.documentElement.classList.add("notranslate");
